import {Config} from '@stripe-internal/conversations-shared-dependencies';

export function parseConfigFromPage(): Config | null {
  const root = document.getElementById('root') as HTMLDivElement;
  if (!root) {
    return null;
  }

  const configText = root.dataset.config as string;
  if (!configText) {
    return null;
  }

  try {
    return JSON.parse(configText);
  } catch {
    return null;
  }
}
